interface IconCalendarFilterOptions {
    cssClasses?: string
}

export function IconCalendarFilter(props: IconCalendarFilterOptions) {
    return (
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={props?.cssClasses}>
            <rect x="1.1625" y="1.93398" width="15.2191" height="14.1773" rx="2.6875" stroke="#1A1717" stroke-width="1.075" stroke-linejoin="round"/>
            <path d="M0.951172 5.69604H16.4694" stroke="black" stroke-width="1.075"/>
            <path d="M4.83008 0.975098V3.154" stroke="black" stroke-width="1.075" stroke-linecap="round"/>
            <g filter="url(#filter0_d_390_47652)">
                <path d="M12.5898 0.975098V3.154" stroke="black" stroke-width="1.075" stroke-linecap="round"/>
            </g>
            <defs>
                <filter id="filter0_d_390_47652" x="7.75273" y="0.4375" width="9.67422" height="11.8539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4.3"/>
                    <feGaussianBlur stdDeviation="2.15"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_390_47652"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_390_47652" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
}
